/**
 * Cross-browser download utility that works in Chrome, Firefox, Safari, and Edge
 * 
 * The key issues with browser downloads:
 * 1. Chrome blocks downloads not triggered by trusted user events
 * 2. Safari has issues with blob URLs
 * 3. Firefox requires the link to be in the DOM
 * 
 * This utility handles all these cases.
 */

export const downloadBlob = (blob, filename) => {
  // Create object URL
  const url = window.URL.createObjectURL(blob);
  
  // Create link element
  const link = document.createElement('a');
  link.href = url;
  link.download = filename;
  link.style.display = 'none';
  
  // Append to body (required for Firefox)
  document.body.appendChild(link);
  
  // Trigger download using requestAnimationFrame for better Chrome compatibility
  requestAnimationFrame(() => {
    link.click();
    
    // Cleanup after delay to ensure download starts
    setTimeout(() => {
      if (document.body.contains(link)) {
        document.body.removeChild(link);
      }
      window.URL.revokeObjectURL(url);
    }, 1000);
  });
};

export const downloadCSV = (data, filename) => {
  // Add BOM for Excel compatibility
  const BOM = '\uFEFF';
  const csvContent = BOM + data;
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  downloadBlob(blob, filename);
};

export const downloadFromResponse = (responseData, filename, format) => {
  const mimeTypes = {
    csv: 'text/csv;charset=utf-8;',
    xlsx: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    xls: 'application/vnd.ms-excel',
    json: 'application/json',
    zip: 'application/zip'
  };
  
  const mimeType = mimeTypes[format] || 'application/octet-stream';
  const blob = new Blob([responseData], { type: mimeType });
  downloadBlob(blob, filename);
};
